import {
  ApplicationInsights,
  SeverityLevel
} from '@microsoft/applicationinsights-web'

const loggerInit = () => {
  const instrumentationKey = InstrumentationKey
  let appInsights = null

  if (instrumentationKey) {
    //InstrumentationKey=49eed907-97c8-4be4-980e-9a59a5150e91;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=3571f1e4-a788-4a4a-bbe9-39b83717c539
    appInsights = new ApplicationInsights({
      config: { connectionString: instrumentationKey }
    })
    appInsights.loadAppInsights()
  }

  function logTrace({ name, severityLevel, properties }) {
    const trace = {
      message: name,
      severityLevel: severityLevel ?? SeverityLevel.Information
    }

    const extraProperties = {
      name,
      properties
    }

    appInsights?.trackTrace({
      ...extraProperties,
      ...trace
    })
  }

  function logError({ name, exception, properties }) {
    const event = {
      name,
      exception,
      properties: {
        ...properties,
        name
      }
    }

    appInsights?.trackException(event)
  }

  return {
    logTrace,
    logError
  }
}

export const logger = loggerInit()
